<template>
  <div>
    <div class="main-page">
      <div class="form-wrapper">
        <el-form label-width="60" inline class="elementui-common-form-styles" v-highlight>
          <el-form-item>
            <el-input style="width: 200px" v-model="queryForm.keyword" clearable placeholder="请标签名称或者媒体标签ID" />
          </el-form-item>
          <el-button type="primary" @click="onQueryAction">查询</el-button>
        </el-form>

        <div>
          <el-button @click="syncModal = true">同步媒体账号标签</el-button>
          <el-button type="primary" @click="addModal = true">添加媒体标签</el-button>
        </div>
      </div>

      <Viewport v-model="tableHeight">
        <el-table v-loading="tableLoading" class="common-el-table-styles" border stripe :data="tableData" :height="tableHeight">
          <el-table-column prop="tagId" label="标签ID" width="80"> </el-table-column>
          <el-table-column prop="mediaTagName" label="媒体标签名称" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="mediaTagId" label="媒体标签ID" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="relationImageNum" label="关联素材数">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onTableRowTagBinding(row, true)">
                {{ row.relationImageNum }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="accountName" label="媒体账号" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="companyName" label="媒体账号主体" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="createOpName" label="新建人"> </el-table-column>
          <el-table-column prop="createTimeText" label="新建时间"> </el-table-column>
          <el-table-column prop="upOpName" label="更新人"> </el-table-column>
          <el-table-column prop="updateTimeText" label="更新时间"> </el-table-column>

          <el-table-column label="操作" width="160">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onTableRowUpdate(row)">编辑</el-button>
              <el-button type="text" @click="onTableRowTagBinding(row)">添加素材</el-button>
              <el-button type="text" @click="onTableRowCheckBindingProgress(row)">绑定进度</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pager">
          <el-pagination
            :current-page.sync="pager.pageIndex"
            :page-size.sync="pager.pageSize"
            :total="total"
            :page-sizes="[30, 50, 100, 200]"
            @current-change="getTableData"
            @size-change="onQueryAction"
            layout="total, sizes, prev, pager, next, jumper"
            background
          >
          </el-pagination>
        </div>
      </Viewport>
    </div>

    <Modal
      title="同步媒体账号标签"
      :loading="syncLoading"
      :visible.sync="syncModal"
      @cancel="onSyncModalClose"
      @confirm="onSyncModalConfirm"
    >
      <MediaTagForm v-if="syncModal" account-multiple ref="syncFormRef" :form="syncForm">
        <template #account="{ accountList }">
          <el-form-item label="管家账号" prop="adAccountIds">
            <el-select style="width: 100%" v-model="syncForm.adAccountIds" multiple collapse-tags filterable>
              <el-option v-for="item in accountList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </template>
      </MediaTagForm>
    </Modal>

    <Modal
      :title="`${addForm.tagId ? '编辑' : '添加'}媒体标签`"
      :loading="confirmLoading"
      :visible.sync="addModal"
      @cancel="onAddModalClose"
      @confirm="onAddModalConfirm"
    >
      <MediaTagForm v-if="addModal" ref="addFormRef" :form="addForm">
        <template #tag-name>
          <el-form-item label="标签名称" prop="tagName">
            <el-input v-model="addForm.tagName" placeholder="标签不超过10个字符"></el-input>
          </el-form-item>

          <el-form-item label="标签类型">
            <span>投放素材包类型</span>
          </el-form-item>
        </template>
      </MediaTagForm>
    </Modal>

    <!--  row-label-id 作为内部媒体素材过滤，
        exlucde-media-tag-id 添加标签时排除本身，只有添加标签时（rowLabelId为空）需要，其他情况传null
      -->
    <MaterialSelector
      v-model="materialSelectorModal"
      :row-label-id="rowLabelId"
      :exclude-media-tag-id="isAddMediaTag && currentRow ? currentRow.tagId : 0"
      is-media-tag
      multiline
      @close="onMaterialSelectorClose"
      @on-select="bindMaterialConfirm"
    >
      <template #tag-select="{ queryForm, qureyAction }">
        <ElFormItem label="素材样式" label-width="90">
          <el-cascader
            v-model="queryForm.imageStyles"
            clearable
            filterable
            collapse-tags
            style="width: 180px"
            :props="{ label: 'content', value: 'labelId', multiple: true }"
            :options="materialStyleTree"
            @change="qureyAction"
          >
          </el-cascader>
        </ElFormItem>

        <ElFormItem label="内容标签">
          <el-select v-model="queryForm.labelId" multiple collapse-tags filterable clearable placeholder="全部" style="width: 180px">
            <el-option v-for="label in labelEnum.contentLabels" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="营销主题标签">
          <el-select v-model="queryForm.typeLabelIds" multiple collapse-tags filterable clearable placeholder="全部" style="width: 180px">
            <el-option v-for="label in labelEnum.marketingLabels" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="媒体标签">
          <el-select
            v-model="queryForm.mediaTagId"
            filterable
            clearable
            placeholder="全部"
            style="width: 180px"
            :disabled="!isAddMediaTag"
            @change="qureyAction"
          >
            <el-option v-for="label in mediaTagList" :key="label.tagId" :value="label.tagId" :label="label.mediaTagName"></el-option>
          </el-select>
        </ElFormItem>
      </template>
    </MaterialSelector>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { MessageBox } from 'element-ui'
import { useRouter } from 'vue-router/composables'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import MediaTagForm from './components/media-tag-form.vue'
import MaterialSelector from '@/components/material/material.vue'
import { bindMediaTag, getAllMediaTagList } from '@/api/material.model.js'
import { MEDIAS } from '@/common/js/constants.js'
import { LABEL_TYPES } from '@/views/material/tags/const.js'

import { useMediaTagPage, useMediaTagSyncForm, useMediaTagAddForm } from './hooks/useMediaTags.js'

import { initPageData, GAME_GROUPS, SYS_TAGS, IMAGE_STYLE_TAG_TREE } from '@/data/global-opts'
// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, SYS_TAGS, IMAGE_STYLE_TAG_TREE])

const router = useRouter()
const { queryForm, pager, total, tableHeight, tableData, tableLoading, getTableData } = useMediaTagPage()
const { syncFormRef, syncForm, syncModal, syncLoading, onSyncModalClose, onSyncModalConfirm } = useMediaTagSyncForm(getTableData)
const { addFormRef, addForm, addModal, confirmLoading, onAddModalClose, onAddModalConfirm } = useMediaTagAddForm(getTableData)

const materialSelectorModal = ref(false)
const rowLabelId = ref(undefined)
const currentRow = ref(null)
const mediaTagList = ref([])
const isAddMediaTag = computed(() => !rowLabelId.value)

const sysTagList = computed(PAGE_REQUIRED_OPTS.SYS_TAGS)
// 素材样式树形结构，与天工素材库筛选样式一致；material.vue 的 getData 会将叶子id打入 labelIdsStr 传给 imageList
const materialStyleTree = computed(PAGE_REQUIRED_OPTS.IMAGE_STYLE_TAG_TREE)
const labelEnum = computed(() => {
  return {
    contentLabels: sysTagList.value.filter((label) => label.labelType === LABEL_TYPES.CONTENT_LABEL),
    materialStyles: sysTagList.value.filter((label) => label.labelType === LABEL_TYPES.MATERIAL_STYLE_LABEL),
    marketingLabels: sysTagList.value.filter((label) => label.labelType === LABEL_TYPES.MARKETING_LABEL),
    threeDLabels: sysTagList.value.filter((label) => label.labelType === LABEL_TYPES.THREED_LABEL)
  }
})

const onQueryAction = () => {
  pager.value.pageIndex = 1
  getTableData()
}

const onTableRowUpdate = (row) => {
  addModal.value = true
  addForm.value = {
    ...row,
    adAccountId: row.accountId,
    tagName: row.mediaTagName
  }
}

const onTableRowTagBinding = (row, hasPayload) => {
  materialSelectorModal.value = true
  currentRow.value = row
  if (hasPayload) {
    // 点击关联数字时传入进行筛选，且禁用下拉， disabled = !isAddMediaTag
    rowLabelId.value = row.tagId
  } else {
    // 添加素材时不需要传入，媒体标签默认为空
    rowLabelId.value = undefined
  }
}

const bindMaterialConfirm = (vals) => {
  const materialIds = vals.map((item) => item.imageId)
  const { tagId } = currentRow.value
  bindMediaTag({ tagId, materialIds }).then((data) => {
    if (data) {
      setTimeout(() => {
        MessageBox.alert(data, '提示', { confirmButtonText: '知道了' })
      }, 500)
    }
  })
}

const onMaterialSelectorClose = () => {
  currentRow.value = null
}

const onTableRowCheckBindingProgress = (row) => {
  router.push({ name: 'mediataglog', query: { tagId: row.tagId } })
}

const getMediaTagList = () => {
  getAllMediaTagList({ mediaId: MEDIAS.GDT }).then((data) => {
    if (data) {
      mediaTagList.value = data
    }
  })
}

getMediaTagList()
onQueryAction()
</script>

<style scoped lang="scss">
.main-page {
  .form-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.pager {
  text-align: right;
  padding: 5px 0;
}
</style>
